import type { DefaultIconProps } from '../../../utils';
import { DefaultIconWrapper, getSemanticTextColor } from '../../../utils';

export const WorkerIcon = ({
  color = 'white',
  width = 15,
  marginLeft,
  marginRight,
  containerSize,
}: DefaultIconProps) => (
  <DefaultIconWrapper marginLeft={marginLeft} marginRight={marginRight} containerSize={containerSize} width={width}>
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 22 22" fill="none">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill={getSemanticTextColor(color)}
        d="M16.0753 6.318H5.94585C5.7276 6.318 5.55322 6.165 5.55322 5.94788V5.53387C5.55322 5.14125 5.79285 4.79362 6.1416 4.64062C6.4026 3.0285 7.42635 1.69987 8.84272 1.00238L9.27922 2.8755C9.32197 3.09375 9.51885 3.22425 9.7146 3.22425C9.75847 3.22425 9.77985 3.22425 9.8226 3.20287C10.0622 3.13762 10.2152 2.89687 10.15 2.65837L9.60547 0.21825C9.67185 0.086625 9.80235 0 9.95422 0H12.067C12.22 0 12.3505 0.086625 12.4157 0.21825L11.8712 2.65837C11.806 2.91937 11.959 3.159 12.1986 3.20287C12.2413 3.22425 12.2627 3.22425 12.3066 3.22425C12.5023 3.22425 12.6992 3.09375 12.7431 2.8755L13.156 1.00238C14.5723 1.69987 15.5961 3.04988 15.8582 4.64062C16.2058 4.79362 16.4455 5.14125 16.4455 5.53387V5.94788C16.4455 6.14363 16.2936 6.318 16.0753 6.318ZM15.9203 7.15511C15.9203 9.86411 13.7254 12.059 11.0164 12.059C8.30626 12.059 6.10913 9.86411 6.10913 7.15511H15.9203ZM13.4187 13C17.2134 14.0988 20 17.7075 20 22H2C2 17.7075 4.7855 14.0988 8.58012 13L11 15.5145L13.4187 13Z"
      />
    </svg>
  </DefaultIconWrapper>
);
